window.addEventListener('load', function() {
  document.querySelectorAll('.Collapsible__Button')?.forEach(button => {
  button.addEventListener('click', (event) => {
    const { target } = event;
    const parent = target.parentNode;

    parent.classList.toggle('active');
    target.setAttribute('aria-expanded', `${target.getAttribute('aria-expanded') !== 'true'}`);
  });
});
}, false);
